import { render, staticRenderFns } from "./InvoiceAdditionalChargesSection.vue?vue&type=template&id=7ddab16e"
import script from "./InvoiceAdditionalChargesSection.vue?vue&type=script&lang=js"
export * from "./InvoiceAdditionalChargesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports